module.exports = __webpack_public_path__ + "static/media/loading_workbooks.9fce7743.gif";